import {put, takeEvery} from "redux-saga/effects";
import {Sport} from "../../../Models/Sport";
import {localStorage} from "../../../lib/storages/localStorage";
import {sportsGetError, sportsGetSuccess} from "./actions";
import * as TYPES from "./types";

export default function* sportsSagas() {
    yield takeEvery(TYPES.SPORTS_GET_REQUEST, sportsGetRequest);
}

function* sportsGetRequest(action) {
    try {
        let items = [];

        if (localStorage.getItem(TYPES.SPORTS_GET_REQUEST)) {
            items = localStorage.getItem(TYPES.SPORTS_GET_REQUEST);
        } else {
            const response = yield Sport.index({
                ...action.payload,
            });

            items = response.data;
            localStorage.setItem(TYPES.SPORTS_GET_REQUEST, items);
        }

        const data = {
            items: items,
            pagination: {total: 0, pages: 0},
        };

        yield put(
            sportsGetSuccess({
                data,
                _params: action.payload,
            })
        );
    } catch (error) {
        yield put(sportsGetError(error));
    }
}
